import { IMinMaxSelectedValue } from "src/models/new-dwelling/new-dwelling.model";
import { EVNDProjectDevelopmentStateType, EVNDSaleStateType } from "src/models/new-dwelling/new-dwelling.enums";
import { EVEstateType, EVOwnership } from "src/models/units/unit-attributes.model";

export interface NewDwellingTypeModel {
    estateType: EVEstateType;
    label: string;
    // CSS class reused from estate-map's estate-icon styling (see scss).
    iconClass: string;
    selected: boolean;
}

export const defaultNewDwellingTypes: NewDwellingTypeModel[] = [
    { estateType: EVEstateType.Leilighet, label: "Leilighet", iconClass: "Leilighet", selected: true },
    { estateType: EVEstateType.Enebolig, label: "Enebolig", iconClass: "Enebolig", selected: true },
    { estateType: EVEstateType.Rekkehus, label: "Rekkehus", iconClass: "Rekkehus", selected: true },
    { estateType: EVEstateType.Tomannsbolig, label: "Tomannsbolig", iconClass: "Tomannsbolig", selected: true },
];

// Eieform — checkbox options (UI). filterFormAPI.ownershipTypes derives the enum array.
// Only Selveier & Borettslag occur in new-dwelling data; the other ownership types are not used.
export interface OwnershipModel {
    value: EVOwnership;
    label: string;
    selected: boolean;
}

export const defaultOwnershipOptions: OwnershipModel[] = [
    { value: EVOwnership.Selveier, label: "Selveier", selected: true },
    { value: EVOwnership.Borettslag, label: "Borettslag", selected: true },
];

// Byggestatus — checkbox options (UI). filterFormAPI.buildStatus derives the enum array.
export interface BuildStatusModel {
    value: EVNDProjectDevelopmentStateType;
    label: string;
    selected: boolean;
}

export const defaultBuildStatusOptions: BuildStatusModel[] = [
    { value: EVNDProjectDevelopmentStateType.Notinitiated, label: "Ikke igangsatt", selected: true },
    { value: EVNDProjectDevelopmentStateType.Initiated, label: "Igangsatt", selected: true },
    { value: EVNDProjectDevelopmentStateType.Completed, label: "Ferdigstilt", selected: true }
];

// Salgstatus — checkbox options (UI). filterFormAPI.saleStatus derives the enum array.
export interface SaleStatusModel {
    value: EVNDSaleStateType;
    label: string;
    selected: boolean;
}

export const defaultSaleStatusOptions: SaleStatusModel[] = [
    { value: EVNDSaleStateType.Forsale, label: "Til salgs", selected: true },
    { value: EVNDSaleStateType.Soldout, label: "Utsolgt", selected: true },
    { value: EVNDSaleStateType.Withdrawn, label: "Trukket", selected: true },
];

export const defaultNumberOfUnits: IMinMaxSelectedValue = { selectedMinValue: 0, selectedMaxValue: 1001 };

export const defaultNumberOfMonthsToShow = 60;

// Tidsperiode — grouped so the time-period child receives a single FieldTree subtree.
export interface NewDwellingTimePeriodModel {
    numberOfMonthsToShow: number | null; // period back in time (range mode)
    useFromToDate: boolean; // explicit from/to date mode
    fromDate: Date | null; // null = unset; form() requires a stable key (not optional) to build FieldTree
    toDate: Date | null;
    isAllSelected: boolean; // "Alle" — no time restriction
}

// Signal Forms model held by NewDwellingSalesStateService (mirrors estate's EstateFilterModel).
// `expanded` is intentionally NOT here — each child keeps it as a local signal.
export interface NewDwellingFilterModel {
    dwellingTypes: NewDwellingTypeModel[]; // Boligtyper
    ownershipOptions: OwnershipModel[]; // Eieform
    buildStatusOptions: BuildStatusModel[]; // Byggestatus
    saleStatusOptions: SaleStatusModel[]; // Salgstatus
    numberOfUnits: IMinMaxSelectedValue; // Antall enheter
    timePeriod: NewDwellingTimePeriodModel; // Tidsperiode
}
